// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__17wrF","collapsed":"styles_collapsed__1n2Nn"};